module.exports = __webpack_public_path__ + "static/media/error.8773ca7e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/alerts/error.svg
// module id = 311
// module chunks = 0